module.exports = __webpack_public_path__ + "img/droplet_red.11402a95.svg";